export const SLACK = [
  'identity.basic',
  'identity.email',
  'identity.team',
  'identity.avatar',
];
export const GOOGLE = [
  'https://www.googleapis.com/auth/userinfo.email',
  'https://www.googleapis.com/auth/userinfo.profile',
];
export const WINDOWS = ['wl.emails', 'wl.signin', 'wl.basic'];
export const APPLE = ['email', 'name'];

export const AUTH0 = 'openid email profile';

export const SLACK_APP = [
  'users:read',
  'users:read.email',
  'chat:write:user',
  'chat:write:bot',
  'channels:read',
  'groups:read',
  'team:read',
  'mpim:read',
  'im:read',
  'im:write',
  'team:read',
];
export const GOOGLE_APP = [
  'https://www.googleapis.com/auth/contacts.readonly',
  'https://www.googleapis.com/auth/admin.directory.user.readonly',
  'https://www.googleapis.com/auth/gmail.send',
];
export const GOOGLE_TOKEN_INFO_URL =
  'https://www.googleapis.com/oauth2/v3/tokeninfo';

export const SLACK_ALL = [...SLACK, ...SLACK_APP];
export const GOOGLE_ALL = [...GOOGLE, ...GOOGLE_APP];
